module.exports = __webpack_public_path__ + "media/images/sp/banner/hokepon_reserve_form-ae4707d7fe56dd99c028aeae8cb83ff8.png";